import { Button, Like16, Dislike16, Close16 } from '@cian/ui-kit';
import * as React from 'react';

import { trackFeedbackOptionClick } from '../../../tracking';
import * as styles from '../styles/styles.css';

interface IQuestionBlockProps {
  onYesButtonClick(): void;
  onNoButtonClick(): void;
  onDidNotPickUpPhoneButtonClick(): void;
}

export function QuestionBlock(props: IQuestionBlockProps) {
  const { onNoButtonClick, onYesButtonClick, onDidNotPickUpPhoneButtonClick } = props;

  const handleNoButtonClick = () => {
    trackFeedbackOptionClick('not_confirmed');

    onNoButtonClick();
  };

  const handleYesButtonClick = () => {
    trackFeedbackOptionClick('confirmed');

    onYesButtonClick();
  };

  const handleDidNotPickUpPhoneButtonClick = () => {
    trackFeedbackOptionClick('no_answer');

    onDidNotPickUpPhoneButtonClick();
  };

  return (
    <div className={styles['question_block']}>
      Подтвердилась ли информация, указанная в объявлении?
      <div className={styles['actions']}>
        <div className={styles['action_button']}>
          <Button
            beforeIcon={<Dislike16 color="current_color" />}
            size="XS"
            theme="fill_secondary"
            onClick={handleNoButtonClick}
          >
            Нет
          </Button>
        </div>

        <div className={styles['action_button']}>
          <Button
            beforeIcon={<Like16 color="current_color" />}
            size="XS"
            theme="fill_secondary"
            onClick={handleYesButtonClick}
          >
            Да
          </Button>
        </div>

        <div className={styles['action_button']}>
          <Button
            size="XS"
            theme="fill_secondary"
            onClick={handleDidNotPickUpPhoneButtonClick}
            beforeIcon={<Close16 color="current_color" />}
          >
            Не взяли трубку
          </Button>
        </div>
      </div>
    </div>
  );
}
